module.exports = __webpack_public_path__ + "media/images/banks/vn-hdbank-db041bc0f2e209b911e2a53605d95bfc.png";